import { render, staticRenderFns } from "./change_password.vue?vue&type=template&id=e56bea46&scoped=true"
import script from "./change_password.vue?vue&type=script&lang=js"
export * from "./change_password.vue?vue&type=script&lang=js"
import style0 from "./change_password.vue?vue&type=style&index=0&id=e56bea46&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e56bea46",
  null
  
)

export default component.exports